<template>
	<div>
		<mainDiv :info="block" />
	</div>
</template>

<script>
	import mainDiv from '@/components/life/main'

	export default {
		props:{
			block:{
				required:false,
				type:Object
			}
		},
		components: {
			mainDiv
		},
		created(){
			this.$emit('headerCur',2);
		}
	}
</script>

<style>
</style>
